import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="container py-4">
      <div className="text-center">
        <h1 className="mb-4">About 10,000 Sentences</h1>
        <div className="mx-auto text-start p-3" style={{ maxWidth: '600px' }}>
          <p>
            This is a Progressive Web App for learning languages through 10,000 sentences.
          </p>
          <p>
            The app provides sentence collections from various sources including Tatoeba and OpenSubtitles.
          </p>
          <p className="mt-5">
            <Link to="/" className="text-primary">← Back to Home</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
